var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertyOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33464 13.3333V7.23333L1.46797 8.66667L0.667969 7.6L8.0013 2L10.668 4.03333V2.66667H12.668V5.56667L15.3346 7.6L14.5346 8.66667L12.668 7.23333V13.3333H9.33464V9.33333H6.66797V13.3333H3.33464ZM6.66797 6.68333H9.33464C9.33464 6.32778 9.2013 6.036 8.93464 5.808C8.66797 5.58 8.35686 5.46622 8.0013 5.46667C7.64575 5.46711 7.33464 5.58111 7.06797 5.80867C6.8013 6.03622 6.66797 6.32778 6.66797 6.68333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyOverview);
export default __webpack_public_path__ + "static/media/propertyOverview.1c61743ea099bd79b3f49eb78b834502.svg";
export { ForwardRef as ReactComponent };